/* Native Shopify transport. One social profile is required, not all three. */
(()=>{
  const initialize=root=>{
    root.querySelector('[data-affiliate-status]')?.focus();
    root.querySelectorAll('[data-affiliate-socials]').forEach(group=>{
      if(group.dataset.initialized)return;
      group.dataset.initialized='true';
      const fields=[...group.querySelectorAll('[data-affiliate-social]')],first=fields[0];
      const isProfile=value=>{
        if(/^@?[\p{L}\p{M}\p{N}._-]+$/u.test(value))return true;
        const candidate=/^(?:www\.)?(?:instagram\.com|tiktok\.com|youtube\.com|youtu\.be)\//i.test(value)?'https://'+value:value;
        try{
          const url=new URL(candidate);
          return /^https?:$/.test(url.protocol)&&!!url.hostname&&!/\s/.test(value);
        }catch{return false;}
      };
      const validate=()=>{
        const empty=!fields.some(field=>field.value.trim());
        fields.forEach(field=>{
          const value=field.value.trim();
          field.setCustomValidity(value&&!isProfile(value)?'Enter @username, username or a profile link.':'');
        });
        first.required=false;
        if(empty)first.setCustomValidity('Add at least one Instagram, TikTok or YouTube username or profile link.');
      };
      fields.forEach(field=>field.addEventListener('input',validate));
      fields.forEach(field=>field.addEventListener('change',validate));
      first.form?.addEventListener('reset',()=>setTimeout(validate,0));
      window.addEventListener('pageshow',validate);
      validate();
    });
  };
  document.querySelectorAll('[data-ns-affiliates]').forEach(initialize);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-ns-affiliates]').forEach(initialize));
})();
